export default __webpack_public_path__ + "static/media/about-us-timeline.f5895d55.png";